module.exports = __webpack_public_path__ + "static/media/clock.835c3fa3.svg";